import { atom } from "jotai";
import { Synonym } from "@/model";

export const editingSynonymAtom = atom<Synonym|undefined>();
